import type { ISocialOffer } from "@bbj-types/offer";
import { useCallback } from "react";
import { axios } from "../axios";
import type { TSocialOfferCreationOrEdition } from "./types";

export const useCreateSocialOffer = () => {
  const [state, execute, cancel] = axios<ISocialOffer, TSocialOfferCreationOrEdition, unknown>(
    {
      url: "/offers/social",
      method: "post",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (socialOffer: TSocialOfferCreationOrEdition) => {
      return execute({ data: socialOffer });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
